// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1LiLo";
export var whiteBg = "styles-module--whiteBg--3tBqt";
export var offWhiteBg = "styles-module--offWhiteBg--3O0A3";
export var container = "styles-module--container--2qxZO";
export var title = "styles-module--title--2RSRR";
export var titleWithoutArrows = "styles-module--titleWithoutArrows--SNAvb";
export var testimonialGroupContainer = "styles-module--testimonialGroupContainer--2BVtl";